import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Navbar.module.css';
import logo from '../../assets/logo/default-monochrome.svg';


const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    // Scroll to top when menu closes (navigation link clicked)
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className={styles.navbar}>
      <div className={styles.navContainer}>
        <NavLink to="/" className={styles.logo} onClick={closeMenu}>
        <img src={logo} alt="SolveDot Labs Logo" style={{ width: '240px', height: 'auto' }} /> {/* Adjusted size and scaling */}
          {/* <Logo /> */}
        </NavLink>

        {/* Hamburger Menu Button - only visible on mobile */}
        <button className={styles.hamburger} onClick={toggleMenu} aria-label="Toggle menu">
          <span className={styles.bar}></span>
          <span className={styles.bar}></span>
          <span className={styles.bar}></span>
        </button>

        {/* Navigation Links */}
        <nav className={isMenuOpen ? `${styles.navMenu} ${styles.active}` : styles.navMenu}>
          <ul className={styles.navLinks}>
            <li>
              <NavLink to="/" className={styles.link} onClick={closeMenu}>Home</NavLink>
            </li>
            <li>
              <NavLink to="/services" className={styles.link} onClick={closeMenu}>Services</NavLink>
            </li>
            <li>
               <NavLink to="/about" className={styles.link} onClick={closeMenu}>About</NavLink>
            </li>
            <li>
              <NavLink to="/contact" className={`${styles.link} ${styles.contactButton}`} onClick={closeMenu}>
                Contact Us
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
